import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useReactiveVar } from '@apollo/client';
import * as Sentry from '@sentry/react';

import { parentUser, staffUser } from '../../../lib/services/auth.service';
import { APP_TITLE } from '../../../../_configuration';
import { parentLoginPathWithNext } from '../../../lib/helpers/parent-links.helpers';
import ErrorPage from '../../_pages/_boilerplate/ErrorPage/error-page.container';

interface IParentRouteProps {
  component: any;
  title?: string;
  exact?: boolean;
  path: string;
}

export const ParentRoute: React.FC<IParentRouteProps> = ({ component: Component, title, ...rest }) => {
  const parent = useReactiveVar(parentUser);
  const staff = useReactiveVar(staffUser);

  // An unauthenticated parent goes to the parent login, even if the user is signed in as a Staff.
  // `next` carries the attempted URL so an email deep link survives the bounce.
  if (!parent) {
    return (
      <Route
        {...rest}
        render={(props) => <Redirect to={parentLoginPathWithNext(props.location.pathname, props.location.search)} />}
      />
    );
  }

  document.title = title || APP_TITLE;

  return (
    <Route
      {...rest}
      render={props => (
        <Sentry.ErrorBoundary fallback={ErrorPage}>
          <Component {...props} />
        </Sentry.ErrorBoundary>
      )}
    />
  );
};
